
export class Open {
  visible = false

  constructor (
    private render: () => void
  ) {}

  show = () => {
    if (this.visible) {
      return
    }

    this.visible = true
    this.render()
  }

  hide = () => {
    if (!this.visible) {
      return
    }

    this.visible = false
    this.render()
  }

  toggle = () => {
    this.visible = !this.visible
    this.render()
  }

}
